import { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import AdminSidebar from './components/AdminSidebar';
import UserManagement from './components/UserManagement';
import BusinessManagement from './components/BusinessManagement';
import PaymentOversight from './components/PaymentOversight';
import AnalyticsDashboard from './components/AnalyticsDashboard';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
  const { user, userProfile, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('analytics');

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/admin-login');
    }
  }, [user, authLoading, navigate]);

  useEffect(() => {
    if (userProfile && userProfile?.user_type !== 'admin') {
      navigate('/login-selection');
    }
  }, [userProfile, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }

  const admin = {
    id: user?.id,
    name: userProfile?.full_name || "Administrador BIZZNET",
    email: user?.email || "admin@bizznet.com",
    type: "admin",
    role: "Super Admin"
  };

  const renderSection = () => {
    switch (activeSection) {
      case 'analytics':
        return <AnalyticsDashboard />;
      case 'users':
        return <UserManagement />;
      case 'businesses':
        return <BusinessManagement />;
      case 'payments':
        return <PaymentOversight />;
      default:
        return <AnalyticsDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={admin} />
      <NavigationBreadcrumbs />
      
      <div className="flex">
        <AdminSidebar 
          activeSection={activeSection}
          onSectionChange={setActiveSection}
        />

        <main className="flex-1 p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {renderSection()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;